module.exports = __webpack_public_path__ + "static/media/image_20.41a8eec1.png";